import * as React from "react";
import PropTypes from "prop-types";

interface CalendarIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  width?: string | number;
  height?: string | number;
}

const ClockIcon: React.FC<CalendarIconProps> = ({ fill = "#1581ED", ...props }) => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? "42"}
      height={height ?? "42"}
      viewBox="0 0 42 42"
      fill={fill}
    >
      <path
        d="M18.1348 6.59473C20.9838 6.02804 23.9373 6.31902 26.6211 7.43066C29.3046 8.5423 31.5981 10.4248 33.2119 12.8398C34.8258 15.2552 35.6875 18.0951 35.6875 21C35.6875 24.8954 34.1402 28.6313 31.3857 31.3857C28.6313 34.1402 24.8954 35.6875 21 35.6875C18.0951 35.6875 15.2552 34.8258 12.8398 33.2119C10.4248 31.5981 8.5423 29.3046 7.43066 26.6211C6.31902 23.9373 6.02804 20.9838 6.59473 18.1348C7.16145 15.2857 8.56017 12.6683 10.6143 10.6143C12.6683 8.56017 15.2857 7.16145 18.1348 6.59473ZM21 6.8125C18.1941 6.8125 15.4512 7.64436 13.1182 9.20312C10.7851 10.762 8.96642 12.978 7.89258 15.5703C6.8188 18.1626 6.53761 21.0156 7.08496 23.7676C7.63239 26.5197 8.98362 29.0481 10.9678 31.0322C12.9519 33.0164 15.4803 34.3676 18.2324 34.915C20.9844 35.4624 23.8373 35.1812 26.4297 34.1074C29.022 33.0336 31.238 31.2149 32.7969 28.8818C34.3556 26.5488 35.1875 23.8059 35.1875 21C35.1875 17.2372 33.6929 13.6284 31.0322 10.9678C28.3716 8.30711 24.7628 6.8125 21 6.8125Z"
        fill="white"
        stroke="white"
        strokeWidth="2.125"
      />
      <path
        d="M26.25 22.3125H21C20.6533 22.308 20.3221 22.1682 20.0769 21.9231C19.8318 21.6779 19.692 21.3467 19.6875 21V12.25C19.6875 11.9019 19.8258 11.5681 20.0719 11.3219C20.3181 11.0758 20.6519 10.9375 21 10.9375C21.3481 10.9375 21.6819 11.0758 21.9281 11.3219C22.1742 11.5681 22.3125 11.9019 22.3125 12.25V19.6875H26.25C26.5981 19.6875 26.9319 19.8258 27.1781 20.0719C27.4242 20.3181 27.5625 20.6519 27.5625 21C27.5625 21.3481 27.4242 21.6819 27.1781 21.9281C26.9319 22.1742 26.5981 22.3125 26.25 22.3125Z"
        fill="white"
      />
    </svg>
  );
};
ClockIcon.propTypes = {
  fill: PropTypes.string,
};
export default ClockIcon;
